module.exports = __webpack_public_path__ + "img/sb03-10.cc5a00fb.png";